"use client";

import * as React from "react";
import { useInView, type UseInViewOptions } from "motion/react";

type RevealProps = React.HTMLAttributes<HTMLDivElement> & {
  children: React.ReactNode;
  animationClass?: string;
  rootMargin?: string;
  once?: boolean;
  amount?: UseInViewOptions["amount"];
};

export function Reveal({
  children,
  animationClass = "animate-in fade-in slide-in-from-bottom-4 duration-700",
  rootMargin = "-100px",
  once = true,
  amount = 0,
  className = "",
  ...props
}: RevealProps) {
  const ref = React.useRef<HTMLDivElement | null>(null);
  const inView = useInView(ref, { once, margin: rootMargin as any, amount });

  return (
    <div
      ref={ref}
      className={`${className} ${
        inView ? animationClass : "opacity-0 translate-y-4"
      }`}
      {...props}
    >
      {children}
    </div>
  );
}
export default Reveal;
